import { Component, Inject } from '@angular/core';

import { MAT_DIALOG_DATA } from '@angular/material/dialog';

export interface MessageDialogData {
	title: string;
	messages: string[];
}

@Component({
	templateUrl: 'message-dialog.html'
})
export class MessageDialogComponent {
	constructor(
		@Inject(MAT_DIALOG_DATA) public data: MessageDialogData
	) {	}
}